import React, { useEffect, useState } from 'react';
import { axiosFetch } from '../../../../utils/AxiosFetch';
import { useNavigate } from 'react-router';
import moment from 'moment';
import {
  Card,
  Avatar,
  CardHeader,
  IconButton,
  Divider,
  CardContent,
  Typography,
  Menu,
  MenuItem,
  Grid,
  ListItemIcon
} from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useDispatch } from "react-redux";
import { deleteComment } from "../../../../redux/actions/deleteComments.action";


let logList = [];

const data = [
  {
    id: 1,
    createdDate: '28 - Aug - 2022',
    createdBy: "Admin Account",
    log: "OKR created"
  },
  {
    id: 2,
    createdDate: ' 28 - Aug - 2022',
    createdBy: "Admin Account",
    log: "Key Result added"
  },
  {
    id: 3,
    createdDate: '28 - Aug - 2022',
    createdBy: "Admin Account",
    log: "Commented Added"
  },]
const AuditLog = (props) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  let okrId = props && props.okrId !== undefined ? props.okrId : null;

  const [logList, setLogList] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [comment_anchorEl, setComment_AnchorEl] = React.useState(null);
  const comment_open = Boolean(comment_anchorEl);
  const [openDialog, setOpenDialog] = useState(false);


  const openConfirmPopup = () => {
    setOpenDialog(true);
  };

  const handleClick = (event) => {

    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClose_comment = () => {
    setComment_AnchorEl(null);
  };

  const handleDelete = () => {

    dispatch(deleteComment());
    window.location.reload();
  }

  const displayLogs = () => {
    axiosFetch({
      method: "get",
      url: `OKRs/okr/log/${okrId}`
    })
      .then((res) => {
        if (res.status === 200) {
          ;
          logList.push(res.data);
          console.log(res.data)
          setLogList(res.data);
        }
        else if (res.status === 401) {
          navigate('/');
        }
      })

      .catch(err => console.error(err));
  }
  useEffect(() => {
    displayLogs();
  }, []);
  return (
    <div className='argus-audit'>

      <Card sx={{ maxWidth: 345 }}>
        <CardHeader
          avatar={
            <Avatar aria-label="recipe">
              R
            </Avatar>
          }
          action={
            <IconButton aria-label="settings">
              <MoreVertIcon />
            </IconButton>
          }
          title="Shrimp and Chorizo Paella"
          subheader="September 14, 2016"
        />

        <CardContent>
          <Typography variant="body2" color="text.secondary">
            This impressive paella is a perfect party dish and a fun meal to cook
            together with your guests. Add 1 cup of frozen peas along with the
            mussels, if you like.
          </Typography>
        </CardContent>
      </Card>

      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={comment_anchorEl}
        open={comment_open}
        onClose={handleClose_comment}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >

        <MenuItem> <IconButton onClick={openConfirmPopup}>
          <IconButton onClick={handleDelete}>
            <DeleteIcon /> Delete
          </IconButton>

        </IconButton></MenuItem>
      </Menu>
    </div>
  )
}

export default AuditLog;